import request from "@/common/request"
import { RegistroDeLiberacaoDTO } from "@/models"
import { AxiosRequestConfig } from "axios"

const basePath = '/registro-de-liberacao'

export const criar = async (registroDeLiberacao: RegistroDeLiberacaoDTO, config?: AxiosRequestConfig): Promise<void> =>
	request.post(`${basePath}`, registroDeLiberacao, config)
